import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, ApiVisa, BasicApiResponseModel, ApiResponseModel } from '../../shared';
import { Core2Config } from '../../shared';
import { StockReservationModel, AutoBinReservationDTOList } from '../../../../../../models/aggregates/erp/stock';

@Injectable({
  providedIn: 'root'
})
export class StockResarvationService extends BaseApiTemplateService<StockReservationModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "inventory-stock-reservation-hdrs/backoffice-ep";

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "inventory-stock-reservation-hdrs/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "inventory-stock-reservation-hdrs/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }

  updateSRPostingStatus(guid: string, posting_status: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/update-posting-status";
    }
    const dto = { guid, posting_status };
    return this.httpClient.put<BasicApiResponseModel<StockReservationModel>>(this.apiUrl, dto, this.getHttpHeader(visa));
  }

  validateAndReserveWithBins(guid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/validate-reserve-with-bin/" + guid;
    }
    return this.httpClient.put<BasicApiResponseModel<string>>(this.apiUrl, null, this.getHttpHeader(visa));
  }

  autoBinReservationFromStockTransfer(dto: AutoBinReservationDTOList, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/mrp-stock-transfer-auto-bin-reservation";
    }
    return this.httpClient.post<ApiResponseModel<StockReservationModel>>(this.apiUrl, dto, this.getHttpHeader(visa));
  }
}